<div class="body-main">
  <!-- Navbar -->
  <div class="navbar">
    @for (nav of getNavObject(); track nav.navName; let i = $index) {
      <div class="navigator" (click)="onNavChange(nav)">
        @if (nav.navName) {
          <div [ngClass]="nav.selectorStyle">
            {{ "manager.refName." + nav.navName + ".title" | translate }}
          </div>
        }
      </div>
    }
  </div>
  <!-- Site Tab -->
  @if (selectedNav === "Sites") {
    <div class="type-holder">
      <app-reference-type
        [service]="siteControllerService"
        [formConfig]="formConfigSite"
        [properties]="siteProperties"
        [recordConfig]="siteRecordConfig"
      ></app-reference-type>
    </div>
  }
  <!-- ContainerTypes Tab -->
  @if (selectedNav === "containerTypes") {
    <div class="type-holder">
      <app-reference-type
        [service]="containerTypeControllerService"
        [formConfig]="formConfigCT"
        [properties]="ctProperties"
        [recordConfig]="ctRecordConfig"
      ></app-reference-type>
    </div>
  }
  <!-- Routes Tab -->
  @if (selectedNav === "Routes") {
    <div class="type-holder">
      <app-reference-type
        [service]="containerTypeAuthSiteControllerService"
        [formConfig]="formConfigCTAuth"
        [properties]="ctAuthProperties"
        [recordConfig]="routeRecordConfig"
      ></app-reference-type>
    </div>
  }
  <!-- Mac Addresses Tab -->
  @if (selectedNav === "macAddresses") {
    <div class="type-holder">
      <app-reference-type
        [service]="macAddressControllerService"
        [formConfig]="formConfigMacAddresses"
        [properties]="macAddressesProperties"
        [recordConfig]="macRecordConfig"
      ></app-reference-type>
    </div>
  }
  <!-- Matching Tab -->
  @if (selectedNav === "Matching") {
    <div class="type-holder">
      <app-matching></app-matching>
    </div>
  }
</div>
